import { isEmpty } from "lodash";
import { useRef, useCallback } from "react";
import { type Action } from "../interfaces/functionTypes/Action";

export type UseReloadItemViewListItemsReturnFunctions = [
  (reloadListItems: (enableSorting: boolean) => void) => void,
  (search: string) => void,
];

export const useReloadItemViewListItems = (setSearch: Action<string>): UseReloadItemViewListItemsReturnFunctions => {
  const reloadListItemsRef = useRef<(enableSorting: boolean) => void>();
  const refetchItemsFromStart = (enableSorting: boolean) => {
    reloadListItemsRef.current?.(enableSorting);
  };
  const setReloadListItems = (reloadListItems: (enableSorting: boolean) => void) => {
    reloadListItemsRef.current = reloadListItems;
  };

  const onSearchChanged = useCallback(
    (search: string) => {
      setSearch(search);
      refetchItemsFromStart(isEmpty(search));
    },
    [setSearch],
  );

  return [setReloadListItems, onSearchChanged];
};
